/* SIDDAMENT light-mode toggle.
 * Injects a floating sun/moon button bottom-right. Persists choice to
 * localStorage. The initial class is set by a tiny inline script in
 * theme.liquid so there's no flash of wrong theme on reload.
 */
(function () {
  if (window.__siddLightToggleInit) return;
  window.__siddLightToggleInit = true;

  var KEY = 'siddLightMode';
  var COLOR_KEY = 'siddCustomBg';
  var SUN = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"></path></svg>';
  var MOON = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>';
  var PAINT = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17l-4 4m8-8l6-6a2.828 2.828 0 1 0-4-4L7 9v4h4z"></path><path d="M3 21h5"></path></svg>';
  var REVERT = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9"></path><path d="M3 3v5h5"></path></svg>';

  function isLight() { return document.documentElement.classList.contains('sidd-light'); }

  function setLight(on) {
    document.documentElement.classList.toggle('sidd-light', !!on);
    try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {}
    updateIcon();
    paintHighSpecRules();
    syncModeButtons();
  }

  // sidd:mode-toggle-2026-10-31: header moon / drawer switch state. The icons swap in CSS off html.sidd-light;
  // this only keeps the button labels and the drawer checkbox in step.
  function syncModeButtons() {
    var on = isLight();
    document.querySelectorAll('[data-sd-mode-toggle]').forEach(function (b) {
      var l = on ? 'Switch to dark mode' : 'Switch to light mode';
      b.setAttribute('aria-label', l);
      b.title = l;
    });
    document.querySelectorAll('[data-sd-mode-switch]').forEach(function (s) { s.checked = !on; });
  }

  // Another tab flipped it, or this page came back from the back/forward cache: follow the saved choice.
  function followSaved() {
    var want = false;
    try { want = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (want === isLight()) return;
    document.documentElement.classList.toggle('sidd-light', want);
    paintHighSpecRules();
    syncModeButtons();
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) followSaved(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) followSaved(); });

  // Pantone Solid Coated → hex approximations.
  // Bootstrapped with a common-code set; the full dataset is lazy-loaded
  // from `assets/pantone.json` (published via the theme) when the user
  // opens the colour popover, so any PMS code in that file can be used.
  var PANTONE_LOADED = false;
  function loadFullPantone(cb) {
    if (PANTONE_LOADED) return cb && cb();
    // Prefer the Shopify-generated versioned URL (exposed by theme.liquid),
    // which auto-busts on asset updates. Fall back to a best-guess path.
    var url = window.__siddPantoneUrl || ('/cdn/shop/t/30/assets/pantone.json?v=' + new Date().toISOString().slice(0, 10));
    fetch(url, { credentials: 'same-origin', cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data) {
          Object.keys(data).forEach(function (k) { PANTONE[k.toLowerCase()] = data[k]; });
          PANTONE_LOADED = true;
        }
      })
      .catch(function (e) { console.warn('[sidd] pantone.json load failed', e); })
      .then(function () { cb && cb(); });
  }

  var PANTONE = {
    '100c':'#f5ec77','101c':'#f4ed47','102c':'#fce300','103c':'#cead00','104c':'#af9800','105c':'#80650a',
    '108c':'#f7d708','109c':'#ffd100','110c':'#daaa00','111c':'#ab8a00','116c':'#ffcd00','117c':'#c99700',
    '123c':'#ffc72c','124c':'#ea7600','130c':'#f2a900','137c':'#ff9e1b','151c':'#ff7f32','158c':'#e87722',
    '165c':'#ff6900','172c':'#fa4616','179c':'#e03c31','185c':'#e4002b','186c':'#c8102e','187c':'#a6192e',
    '192c':'#e40046','199c':'#d50032','201c':'#9d2235','202c':'#862633','206c':'#ce0058','212c':'#ef3e79',
    '213c':'#e31c79','219c':'#d0006f','232c':'#ec008c','234c':'#a71680','248c':'#9b26b6','254c':'#8031a7',
    '265c':'#9063cd','266c':'#5e35b1','267c':'#5f249f','268c':'#582c83','269c':'#512d6d','272c':'#7474c1',
    '280c':'#012169','281c':'#00205b','285c':'#0072ce','286c':'#003da5','289c':'#0c2340','293c':'#003da5',
    '295c':'#002855','300c':'#005eb8','301c':'#003da5','306c':'#00b5e2','312c':'#00a9e0','313c':'#0093b2',
    '320c':'#009ca6','321c':'#008c95','323c':'#006b5f','326c':'#00a499','330c':'#005a4f','335c':'#00664f',
    '341c':'#00854a','347c':'#009739','348c':'#00843d','354c':'#00b140','355c':'#009639','361c':'#43b02a',
    '362c':'#4c9f38','368c':'#78be20','369c':'#64a70b','374c':'#d0df00','375c':'#97d700','382c':'#c4d600',
    '383c':'#a8ad00','397c':'#c4b000','400c':'#bfb8af','401c':'#aaa39a','404c':'#8f8985','425c':'#54585a',
    '429c':'#a2aaad','431c':'#5b6770','432c':'#333f48','433c':'#1d252d','444c':'#818a8f','445c':'#505759',
    '446c':'#3f4444','447c':'#272c2f','448c':'#4a412a','465c':'#b9975b','469c':'#693f23','476c':'#4e3629',
    '485c':'#da291c','486c':'#eaaa00','497c':'#4e2a1e','500c':'#e7a9a3','505c':'#6f2c3f','512c':'#77216f',
    '513c':'#93328e','521c':'#b784a7','527c':'#702f8a','534c':'#1b365d','541c':'#003865','548c':'#003145',
    '554c':'#205c40','555c':'#26734d','560c':'#1d4f3f','567c':'#18453b','574c':'#5d6324','577c':'#cbc08b',
    '583c':'#b5bd00','584c':'#d1d955','609c':'#d0d09a','611c':'#d5c91f','618c':'#a39200','620c':'#00b388',
    '624c':'#85b09a','630c':'#9cdbd9','633c':'#005b82','640c':'#0091c2','648c':'#002855','653c':'#2b5d89',
    '660c':'#3a6cb0','662c':'#001a72','663c':'#edebe6','664c':'#e4e3db','671c':'#eec2d8','676c':'#b4295a',
    '684c':'#c9a0a4','691c':'#deccc6','698c':'#f9ddd5','701c':'#ed8baa','705c':'#ffc1cc','711c':'#c8102e',
    '715c':'#ed8b00','716c':'#ea7600','717c':'#d25a1e','719c':'#d3964f','724c':'#653415','731c':'#5c2e1f',
    '737c':'#d6a461','739c':'#b08d57','740c':'#b07c4a','743c':'#b77729','751c':'#a56a35','760c':'#8b5a2b',
    '805c':'#ff4f6b','806c':'#ff3eb5','808c':'#00cc99','810c':'#ffe552','811c':'#ffb81c','812c':'#ff2667',
    '813c':'#ea0e6b','814c':'#9063cd','871c':'#8a6f48','872c':'#85714d','873c':'#866d4b','874c':'#8b6f4e',
    '875c':'#8b7355','876c':'#97674c','877c':'#8a8d8f',
    'black':'#000000','blackc':'#2d2926','whitec':'#ffffff',
    'processblackc':'#1d1d1b','processcyanc':'#0085ca','processmagentac':'#d0006f','processyellowc':'#ffd100',
  };

  function normalizePantone(s) {
    return s.toLowerCase()
      .replace(/pantone\s*/g, '')
      .replace(/pms\s*/g, '')
      .replace(/\s+/g, '')
      .replace(/-/g, '');
  }

  // Tries many variations so users can type shorthand like "6 C" (Black 6C),
  // "021 U" (Orange 021 U), "Red 032" (Red 032 C/U), or just "red".
  function lookupPantone(input) {
    var key = normalizePantone(input);
    var candidates = [];
    // 1. Exact
    candidates.push(key);
    // 2. Add default suffix if none
    if (!/[cu]$/.test(key)) {
      candidates.push(key + 'c');
      candidates.push(key + 'u');
    }
    // 3. Cross-fall between coated/uncoated (u<->c) when only one variant exists
    if (/u$/.test(key)) candidates.push(key.replace(/u$/, 'c'));
    if (/c$/.test(key)) candidates.push(key.replace(/c$/, 'u'));
    // 4. Named-colour shortcuts: "6c" → black6c, "021c" → orange021c, etc.
    //    Only runs when the bare part is purely numeric. Otherwise queries
    //    like "021 C" would wrongly pick up "blackc" via the generic family
    //    fallback.
    var numOnly = key.replace(/[cu]$/, '');
    var suffix = /[cu]$/.test(key) ? key.slice(-1) : 'c';
    if (/^\d+$/.test(numOnly)) {
      var namedFamilies = ['black','red','orange','yellow','blue','purple','violet','green',
                           'warmred','coolred','reflexblue','rubinered','rhodaminered',
                           'warmgray','coolgray','processblack','processcyan','processmagenta','processyellow'];
      namedFamilies.forEach(function (fam) {
        candidates.push(fam + numOnly + suffix);
        candidates.push(fam + numOnly + (suffix === 'c' ? 'u' : 'c'));
      });
    }
    for (var i = 0; i < candidates.length; i++) {
      if (PANTONE[candidates[i]]) return PANTONE[candidates[i]];
    }
    // 5. Nearest-neighbour fallback for purely-numeric codes: find the
    //    closest number in the same thousands bucket and use its hex.
    //    Means every plausible PMS code resolves to SOMETHING rather than
    //    erroring out.
    if (/^\d+$/.test(numOnly)) {
      var target = parseInt(numOnly, 10);
      var bucket = Math.floor(target / 1000);
      var pantoneKeys = Object.keys(PANTONE);
      var bestKey = null, bestDist = Infinity;
      for (var j = 0; j < pantoneKeys.length; j++) {
        var k = pantoneKeys[j];
        var m = k.match(/^(\d+)([cu])?$/);
        if (!m) continue;
        var n = parseInt(m[1], 10);
        if (Math.floor(n / 1000) !== bucket) continue;
        var requiredSuffix = (m[2] || 'c');
        if (suffix && suffix !== requiredSuffix) continue;
        var d = Math.abs(n - target);
        if (d < bestDist) { bestDist = d; bestKey = k; }
      }
      if (bestKey) return PANTONE[bestKey];
      // Widen search: any numeric code if bucket lookup failed
      bestKey = null; bestDist = Infinity;
      for (var j2 = 0; j2 < pantoneKeys.length; j2++) {
        var k2 = pantoneKeys[j2];
        var m2 = k2.match(/^(\d+)([cu])?$/);
        if (!m2) continue;
        var n2 = parseInt(m2[1], 10);
        if (suffix && (m2[2] || 'c') !== suffix) continue;
        var d2 = Math.abs(n2 - target);
        if (d2 < bestDist) { bestDist = d2; bestKey = k2; }
      }
      if (bestKey) return PANTONE[bestKey];
    }
    return null;
  }

  function parseColor(input) {
    if (!input) return null;
    input = input.trim();
    // Standard hex with or without #
    if (/^#?[0-9a-f]{6}$/i.test(input)) return '#' + input.replace('#', '').toLowerCase();
    if (/^#?[0-9a-f]{3}$/i.test(input)) {
      var h = input.replace('#', '').toLowerCase();
      return '#' + h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    }
    // rgb(r, g, b)
    var rgb = input.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/i);
    if (rgb) {
      function hex(n){n=parseInt(n,10); return (n<16?'0':'')+n.toString(16);}
      return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    return lookupPantone(input);
  }

  // WCAG relative luminance
  function luminance(hex) {
    var h = hex.replace('#', '');
    var r = parseInt(h.slice(0,2),16)/255, g = parseInt(h.slice(2,4),16)/255, b = parseInt(h.slice(4,6),16)/255;
    function lin(c){ return c <= 0.03928 ? c/12.92 : Math.pow((c+0.055)/1.055, 2.4); }
    return 0.2126*lin(r) + 0.7152*lin(g) + 0.0722*lin(b);
  }

  function applyCustomBg(color) {
    var s = document.getElementById('sidd-custom-bg-style');
    if (!color) {
      if (s) s.remove();
      document.documentElement.classList.remove('sidd-custom-bg');
      try { localStorage.removeItem(COLOR_KEY); } catch (e) {}
    } else {
      // Normalise input (hex / pantone / rgb) to a hex string
      var parsed = parseColor(color) || color;
      if (!s) {
        s = document.createElement('style');
        s.id = 'sidd-custom-bg-style';
        document.head.appendChild(s);
      }
      s.textContent = (
        'html.sidd-custom-bg, html.sidd-custom-bg body,' +
        'html.sidd-custom-bg .gradient,' +
        'html.sidd-custom-bg .shopify-section,' +
        'html.sidd-custom-bg [class*="color-scheme-"] {' +
          'background-color: ' + parsed + ' !important;' +
          'background-image: none !important;' +
        '}'
      );
      document.documentElement.classList.add('sidd-custom-bg');
      try { localStorage.setItem(COLOR_KEY, parsed); } catch (e) {}

      // Auto-pick readable text mode for the chosen background
      if (/^#[0-9a-f]{6}$/i.test(parsed)) {
        var lum = luminance(parsed);
        // lum > 0.5 means light colour — switch to light mode (dark text);
        // else dark mode (light text). Threshold tuned for reasonable feel.
        setLight(lum > 0.5);
      }
    }
    updateRevertVisibility();
  }

  function getCustomBg() {
    try { return localStorage.getItem(COLOR_KEY); } catch (e) { return null; }
  }

  function updateRevertVisibility() {
    var btn = document.getElementById('sidd-revert-bg');
    if (!btn) return;
    btn.style.display = getCustomBg() ? 'flex' : 'none';
  }

  // Theme has inline CSS like `#shopify-section-...__header nav a { color: #fff !important }`
  // — an ID selector with !important. Classes can't beat it, so we set inline
  // styles (which ARE beaten by !important-ID rules... unless we also use
  // !important on the inline style via setProperty).
  function paintHighSpecRules() {
    var isLight = document.documentElement.classList.contains('sidd-light');
    var sel = 'header nav a, [id*="shopify-section-sections-"] nav a, .mega-menu__link, .mega-menu a, .header__menu-item, .header__submenu a, .header__inline-menu a';
    document.querySelectorAll(sel).forEach(function (el) {
      if (!isLight) {
        if (!el.hasAttribute('data-sd-lp')) return;
        var was = el.getAttribute('data-sd-lp').split('|');
        if (was[0]) el.style.setProperty('color', was[0], was[1] || ''); else el.style.removeProperty('color');
        el.removeAttribute('data-sd-lp');
        return;
      }
      if (!el.hasAttribute('data-sd-lp')) el.setAttribute('data-sd-lp', el.style.getPropertyValue('color') + '|' + el.style.getPropertyPriority('color'));
      // Gradient CTA buttons get white text (handled by CSS but inline beats CSS)
      el.style.setProperty('color', el.classList.contains('sidd-gradient-btn') ? '#ffffff' : 'rgb(20, 20, 20)', 'important');
    });
  }

  function updateIcon() {
    var btn = document.getElementById('sidd-light-toggle');
    if (!btn) return;
    btn.innerHTML = isLight() ? MOON : SUN;
    btn.setAttribute('aria-pressed', isLight() ? 'true' : 'false');
    btn.title = isLight() ? 'Switch to dark mode' : 'Switch to light mode';
  }

  // Collection-specific body tagging (used by CSS for layout tweaks)
  if (/\/collections\/3d-blasters/i.test(location.pathname)) {
    (document.body || document.documentElement).classList.add('sidd-blasters');
  }
  if (/\/pages\/tpu/i.test(location.pathname)) {
    (document.body || document.documentElement).classList.add('sidd-page-tpu');
  }

  // Tag Prusa/Prusament product cards — their photos have black backgrounds
  // baked in. On the white page they'd show as harsh black rectangles; we
  // give the card a dark tile so the image blends seamlessly.
  function tagPrusaCards() {
    // Listing pages: per-card tagging
    document.querySelectorAll('.card-wrapper, .card').forEach(function (card) {
      // Only tag Prusament *filament* cards — those photos are shot on black.
      // Prusa *spare parts* (nozzles etc) already have clean backgrounds, so
      // skip anything that looks like a part or accessory.
      var txt = (card.textContent || '');
      var isPrusament = /prusament/i.test(txt);
      if (!isPrusament) {
        if (card.classList.contains('sidd-prusa-card')) {
          card.classList.remove('sidd-prusa-card');
        }
        return;
      }
      if (!card.classList.contains('sidd-prusa-card')) {
        card.classList.add('sidd-prusa-card');
      }
    });
  }
  if (document.readyState !== 'loading') tagPrusaCards();
  else document.addEventListener('DOMContentLoaded', tagPrusaCards);
  if (window.MutationObserver) {
    new MutationObserver(tagPrusaCards).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Tag gradient mega-menu buttons so light mode can re-style them
  function tagGradientButtons() {
    document.querySelectorAll('.mega-menu__link, a.mega-menu__link--level-2').forEach(function (el) {
      if (el.classList.contains('sidd-gradient-btn')) return;
      var bg = getComputedStyle(el).backgroundImage;
      if (bg && /linear-gradient/.test(bg) && /0,\s*255,\s*255|119,\s*51,\s*255|255,\s*34,\s*170/.test(bg)) {
        el.classList.add('sidd-gradient-btn');
      }
    });
  }
  if (document.readyState !== 'loading') tagGradientButtons();
  else document.addEventListener('DOMContentLoaded', tagGradientButtons);
  // Mega menus may mount late — re-run on body mutation
  if (window.MutationObserver) {
    new MutationObserver(tagGradientButtons).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Site-wide "header chip" — user pins a colour from the colour-matcher,
  // it follows them across every OTHER page. Hidden on the matcher page
  // itself (full chip is already shown there).
  function renderHeaderChip() {
    var existing = document.getElementById('sidd-header-chip');
    // Don't show on the matcher page itself
    if (/\/pages\/(colour-matcher|color-match)/i.test(location.pathname)) {
      if (existing) existing.remove();
      return;
    }
    var raw = null;
    try { raw = localStorage.getItem('siddHeaderChip'); } catch (e) {}
    if (!raw) {
      if (existing) existing.remove();
      return;
    }
    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || !data.hex) return;

    // Find a mount point next to the logo. Fall back to the header or body.
    var mountHost = document.querySelector('.header__heading-link, .header__heading-logo-wrapper, .header__heading') ||
                    document.querySelector('.header-wrapper, .header');
    if (!mountHost) { mountHost = document.body; }

    var chip = existing || document.createElement('div');
    chip.id = 'sidd-header-chip';
    var codeLabel = data.code
      ? (data.mode === 'pantone' ? 'SIDDATONE ' + data.code.replace(/pms\s*/gi,'').replace(/pantone\s*/gi,'').replace(/\s+/g,' ').toUpperCase() : 'HEX ' + data.hex.toUpperCase())
      : 'HEX ' + data.hex.toUpperCase();
    chip.innerHTML =
      '<span class="sidd-hc-swatch" style="background:' + data.hex + '"></span>' +
      '<span class="sidd-hc-label">' + codeLabel + '</span>' +
      '<button class="sidd-hc-close" type="button" aria-label="Remove pinned colour">×</button>';

    if (!existing) {
      // Insert after the logo link
      if (mountHost.parentNode) mountHost.parentNode.insertBefore(chip, mountHost.nextSibling);
      else document.body.appendChild(chip);
    }

    chip.querySelector('.sidd-hc-close').onclick = function (e) {
      e.preventDefault(); e.stopPropagation();
      try { localStorage.removeItem('siddHeaderChip'); } catch (e) {}
      chip.remove();
      var bigChip = document.getElementById('sidd-hc-big');
      if (bigChip) bigChip.remove();
    };

    // Click on swatch/label to open a big preview in-place for comparison
    function openBigChip() {
      var existing = document.getElementById('sidd-hc-big');
      if (existing) { existing.remove(); return; }
      var big = document.createElement('div');
      big.id = 'sidd-hc-big';
      var rgb = [parseInt(data.hex.slice(1,3),16), parseInt(data.hex.slice(3,5),16), parseInt(data.hex.slice(5,7),16)];
      var label = data.code
        ? (data.mode === 'pantone' ? 'SIDDATONE ' + data.code.replace(/pms\s*/gi,'').replace(/pantone\s*/gi,'').replace(/\s+/g,' ').toUpperCase() : 'Hex ' + data.hex.toUpperCase())
        : 'Hex ' + data.hex.toUpperCase();
      big.innerHTML =
        '<div class="sidd-hc-big-card">' +
          '<div class="sidd-hc-big-color" style="background:' + data.hex + '"></div>' +
          '<div class="sidd-hc-big-body">' +
            '<div class="sidd-hc-big-label">' + label + '</div>' +
            '<div class="sidd-hc-big-hex">' + data.hex.toUpperCase() + ' · RGB ' + rgb.join(', ') + '</div>' +
            '<button class="sidd-hc-big-close" type="button">Close</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(big);
      big.querySelector('.sidd-hc-big-close').onclick = function () { big.remove(); };
    }
    chip.querySelector('.sidd-hc-swatch').onclick = openBigChip;
    chip.querySelector('.sidd-hc-label').onclick = openBigChip;
    chip.style.cursor = 'pointer';
  }
  window.__siddRenderHeaderChip = renderHeaderChip;

  // Hide / show state — toggle can be swiped/clicked away
  var HIDDEN_KEY = 'siddToggleHidden';
  function isToggleHidden() { try { return localStorage.getItem(HIDDEN_KEY) === '1'; } catch (e) { return false; } }
  function setToggleHidden(on, persist) {
    if (persist !== false) { try { localStorage.setItem(HIDDEN_KEY, on ? '1' : '0'); } catch (e) {} }
    var w = document.getElementById('sidd-toggle-wrap');
    var t = document.getElementById('sidd-toggle-tab');
    if (w) w.classList.toggle('sidd-toggle-hidden', !!on);
    if (t) t.classList.toggle('sidd-toggle-tab-visible', !!on);
  }

  function init() {
    if (document.getElementById('sidd-light-toggle')) return;
    renderHeaderChip();

    // --- sidd:mode-toggle-2026-10-31 ---------------------------------------------
    // The buttons are server-rendered by snippets/sd-mode-toggle.liquid (moon in the header
    // at 990px+, "Dark mode" switch in the menu drawer below that). layout/theme.liquid sets
    // html.sidd-light before first paint; this wires the clicks and repaints the nav links the
    // theme pins with ID + !important rules, including mega menus that mount later.
    document.querySelectorAll('[data-sd-mode-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); setLight(!isLight()); });
    });
    document.querySelectorAll('[data-sd-mode-switch]').forEach(function (s) {
      s.addEventListener('change', function () { setLight(!s.checked); });
    });
    syncModeButtons();
    if (isLight()) paintHighSpecRules();
    if (window.MutationObserver) {
      var sdModeMo = new MutationObserver(function () { if (isLight()) paintHighSpecRules(); });
      document.querySelectorAll('header, [id*="shopify-section-sections-"]').forEach(function (h) { sdModeMo.observe(h, { childList: true, subtree: true }); });
    }

    // --- light/dark toggle pulled out 2026-09-01 -------------------------
    // (the old bottom-left cluster stays out; the moon above replaces its sun/moon button)
    // Everything below builds the bottom-left cluster (sun/moon toggle,
    // paint custom-background picker, revert, hide tab) and restores a saved
    // custom bg. Stopping here leaves the site permanently on the default
    // dark theme. The colour-matcher header chip above still runs, as do
    // tagPrusaCards / tagGradientButtons / the body tagging outside init().
    // To bring the toggle back: delete this return.
    return;
    // ---------------------------------------------------------------------

    // Container so toggle + paint + revert sit together bottom-left
    var wrap = document.createElement('div');
    wrap.id = 'sidd-toggle-wrap';

    var btn = document.createElement('button');
    btn.id = 'sidd-light-toggle';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Toggle light/dark mode');
    btn.addEventListener('click', function () { setLight(!isLight()); });
    wrap.appendChild(btn);

    // Paint icon — appears on hover; opens a popover with swatch + text input
    var paint = document.createElement('button');
    paint.id = 'sidd-paint-btn';
    paint.type = 'button';
    paint.title = 'Pick custom background colour';
    paint.setAttribute('aria-label', 'Pick custom background colour');
    paint.innerHTML = PAINT;
    wrap.appendChild(paint);

    // Popover
    var pop = document.createElement('div');
    pop.id = 'sidd-color-pop';
    pop.innerHTML =
      '<label class="sidd-pop-label">Colour wheel</label>' +
      '<input type="color" id="sidd-color-picker" value="' + (getCustomBg() || '#ffffff') + '">' +
      '<label class="sidd-pop-label sidd-pop-or">Hex code</label>' +
      '<input type="text" id="sidd-hex-text" placeholder="#ff6600" autocomplete="off">' +
      '<label class="sidd-pop-label sidd-pop-or">Pantone code</label>' +
      '<input type="text" id="sidd-pantone-text" placeholder="186 C, PMS 286, Pantone 2583" autocomplete="off">' +
      '<div class="sidd-pop-row">' +
        '<button type="button" id="sidd-color-apply">Apply</button>' +
        '<button type="button" id="sidd-color-close">Close</button>' +
      '</div>' +
      '<div id="sidd-color-error" class="sidd-pop-err"></div>';
    wrap.appendChild(pop);

    var picker = pop.querySelector('#sidd-color-picker');
    var hexInput = pop.querySelector('#sidd-hex-text');
    var pantoneInput = pop.querySelector('#sidd-pantone-text');
    var err = pop.querySelector('#sidd-color-error');

    picker.addEventListener('input', function (e) {
      hexInput.value = e.target.value;
      pantoneInput.value = '';
      err.textContent = '';
      applyCustomBg(e.target.value);
    });

    function applyFromInputs() {
      // Pantone takes priority if both filled; else fall back to hex.
      var pantoneRaw = pantoneInput.value.trim();
      var hexRaw = hexInput.value.trim();
      var parsed = null;
      if (pantoneRaw) {
        parsed = parseColor(pantoneRaw);
        if (!parsed) { err.textContent = 'Pantone code not recognised. Try a different code or use hex.'; return; }
      } else if (hexRaw) {
        parsed = parseColor(hexRaw);
        if (!parsed) { err.textContent = 'Invalid hex. Use #ff6600 or ff6600.'; return; }
      } else {
        err.textContent = 'Enter a hex or Pantone code.';
        return;
      }
      err.textContent = '';
      picker.value = parsed;
      hexInput.value = parsed;
      applyCustomBg(parsed);
    }

    [hexInput, pantoneInput].forEach(function (inp) {
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyFromInputs(); } });
    });
    pop.querySelector('#sidd-color-apply').addEventListener('click', applyFromInputs);
    pop.querySelector('#sidd-color-close').addEventListener('click', function () { pop.classList.remove('open'); });

    paint.addEventListener('click', function () {
      pop.classList.toggle('open');
      if (pop.classList.contains('open')) {
        loadFullPantone();   // fetch the full Pantone table on first open
        setTimeout(function(){ hexInput.focus(); }, 50);
      }
    });

    // Close popover on outside click
    document.addEventListener('click', function (e) {
      if (!pop.classList.contains('open')) return;
      if (pop.contains(e.target) || paint.contains(e.target)) return;
      pop.classList.remove('open');
    });

    // Revert button — only visible when a custom colour is saved
    var revert = document.createElement('button');
    revert.id = 'sidd-revert-bg';
    revert.type = 'button';
    revert.title = 'Revert to default background';
    revert.setAttribute('aria-label', 'Revert to default background');
    revert.innerHTML = REVERT;
    revert.addEventListener('click', function () { applyCustomBg(null); });
    wrap.appendChild(revert);

    // Hide button — collapses the cluster off-screen
    var hide = document.createElement('button');
    hide.id = 'sidd-toggle-hide';
    hide.type = 'button';
    hide.title = 'Hide';
    hide.setAttribute('aria-label', 'Hide toggle');
    hide.innerHTML = '‹';
    hide.addEventListener('click', function () { setToggleHidden(true); });
    wrap.appendChild(hide);

    document.body.appendChild(wrap);

    // Re-show tab — small handle at the screen edge when toggle is hidden
    var tab = document.createElement('button');
    tab.id = 'sidd-toggle-tab';
    tab.type = 'button';
    tab.title = 'Show theme controls';
    tab.setAttribute('aria-label', 'Show theme controls');
    tab.innerHTML = '›';
    var reshownAt = 0;
    tab.addEventListener('click', function () { setToggleHidden(false); reshownAt = Date.now(); });
    document.body.appendChild(tab);

    // Auto-tuck on scroll — any real scroll collapses the cluster so it's
    // out of the way (mobile and desktop). Not persisted, so it still shows
    // on the next page load; the edge tab brings it back any time.
    var autoY = window.pageYOffset || 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var dy = Math.abs(y - autoY);
      autoY = y;
      if (dy < 8) return;                         // ignore jitter
      if (Date.now() - reshownAt < 1200) return;  // just re-opened via tab
      var w = document.getElementById('sidd-toggle-wrap');
      if (!w || w.classList.contains('sidd-toggle-hidden')) return;
      if (pop.classList.contains('open')) return; // mid colour-pick
      setToggleHidden(true, false);
    }, { passive: true });

    // Touch swipe on mobile — drag the wrap left to hide
    var startX = 0, startY = 0, swiping = false;
    wrap.addEventListener('touchstart', function (e) {
      if (e.target.closest('button')) return;   // let buttons handle their own taps
      var t = e.touches[0]; startX = t.clientX; startY = t.clientY; swiping = true;
    }, { passive: true });
    wrap.addEventListener('touchmove', function (e) {
      if (!swiping) return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = Math.abs(t.clientY - startY);
      if (dx < -30 && dy < 30) { setToggleHidden(true); swiping = false; }
    }, { passive: true });
    wrap.addEventListener('touchend', function () { swiping = false; }, { passive: true });
    // Tab swipe right to show
    var tabStartX = 0, tabSwiping = false;
    tab.addEventListener('touchstart', function (e) { tabStartX = e.touches[0].clientX; tabSwiping = true; }, { passive: true });
    tab.addEventListener('touchmove', function (e) {
      if (!tabSwiping) return;
      var dx = e.touches[0].clientX - tabStartX;
      if (dx > 25) { setToggleHidden(false); reshownAt = Date.now(); tabSwiping = false; }
    }, { passive: true });

    // Restore previously saved hidden state; on mobile start collapsed
    // (not persisted — the edge tab re-opens it, desktop unaffected)
    var mobileDefault = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (isToggleHidden()) setToggleHidden(true);
    else if (mobileDefault) setToggleHidden(true, false);

    // Re-apply any saved custom background
    var saved = getCustomBg();
    if (saved) applyCustomBg(saved);

    updateIcon();
    updateRevertVisibility();
    paintHighSpecRules();
    // Mega-menus re-render/append their contents on open — re-paint when DOM changes
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { paintHighSpecRules(); });
      var headers = document.querySelectorAll('header, [id*="shopify-section-sections-"]');
      headers.forEach(function (h) { mo.observe(h, { childList: true, subtree: true }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
